import { useEffect } from "react"

import { useLocalSearchParams } from "expo-router"

import { promptOpenWebsiteInNewTab } from "src/utils/openWebsiteDialog"
import { backToRoot } from "src/utils/routerHelpers"

/** Web never embeds websites — prompt to open in a new tab and return to the previous screen. */
export default function WebBrowserScreen() {
  const { url: urlParam } = useLocalSearchParams<{
    url?: string | string[]
  }>()
  const resolvedUrl = Array.isArray(urlParam) ? urlParam[0] : urlParam

  useEffect(() => {
    if (resolvedUrl) {
      promptOpenWebsiteInNewTab(resolvedUrl)
      backToRoot()
    }
  }, [resolvedUrl])

  return null
}
